( function ( _s ) {
	_s.fn.header = function () {
		return this.each( header => {
			const _header = _s( header );
			const _notificationBar = _header.find( '.notification-bar' );
			// One links container now serves both breakpoints (it becomes the drawer at
			// ≤880px), so the submenu handling below binds to it rather than to the old
			// separate .navbar-desktop / .navbar-mobile wrappers.
			const _desktopNavBar = _header.find( '.nav-links' );
			const _navbarBrand = _header.find( '.navbar-brand' );
			const _logo = _navbarBrand.find( 'img' );

			const isSubmenuExpanded = _toggle => {
				return _toggle.hasClass( 'show' );
			};

			// ─── Member avatar dropdown (minimal accessible toggle) ───
			const _navUser = _header.find( '.nav-user' );

			_navUser.each( navUser => {
				const _navUserEl = _s( navUser );
				const _avatar = _navUserEl.find( '.nav-avatar' );
				const _menu = _navUserEl.find( '.nav-menu' );
				const avatarEl = _avatar.firstElement();
				const menuEl = _menu.firstElement();

				if ( ! avatarEl || ! menuEl ) return;

				const closeMenu = () => {
					_menu.removeClass( 'is-open' );
					_avatar.attr( 'aria-expanded', 'false' );
				};

				const openMenu = () => {
					_menu.addClass( 'is-open' );
					_avatar.attr( 'aria-expanded', 'true' );
					const firstItem = _menu.find( 'a' ).firstElement();
					if ( firstItem ) firstItem.focus();
				};

				_avatar.on( 'click', e => {
					e.preventDefault();
					if ( _menu.hasClass( 'is-open' ) ) {
						closeMenu();
					} else {
						openMenu();
					}
				} );

				_avatar.on( 'keydown', e => {
					if ( e.key === 'ArrowDown' ) {
						e.preventDefault();
						if ( ! _menu.hasClass( 'is-open' ) ) {
							openMenu();
						}
					}
				} );

				// Close on outside click.
				_s( document ).on( 'click', e => {
					if ( ! _menu.hasClass( 'is-open' ) ) return;
					if ( ! navUser.contains( e.target ) ) {
						closeMenu();
					}
				} );

				// Close on Escape, restoring focus to the avatar.
				_navUserEl.on( 'keydown', e => {
					if ( e.key === 'Escape' && _menu.hasClass( 'is-open' ) ) {
						closeMenu();
						avatarEl.focus();
					}
				} );
			} );

			let autohideOnScrollHeight = parseInt( window.getRootProperty( '--body-top-padding' ) );
			let scrolled = 0;

			const scroll = () => {
				const currentScrollY = window.scrollY;

				_header.toggleClass(
					'show',
					currentScrollY < scrolled && ! _header.hasClass( 'locked-hidden' )
				);

				if ( currentScrollY < 1 && scrolled > 0 ) {
					_header.removeClass( 'navbar-fixed' );
				}

				if ( currentScrollY > scrolled && currentScrollY > autohideOnScrollHeight ) {
					_header.toggleClass( 'navbar-fixed', true );

					/** Add a small delay when adding the "animate" class */
					setTimeout( () => {
						_header.toggleClass( 'animate', true );
					}, 50 );
				}

				if ( currentScrollY <= autohideOnScrollHeight ) {
					_header.toggleClass( 'animate', false );
				}

				scrolled = currentScrollY;
			};

			const bodyOverflowHidden = ( lock = false ) => {
				if ( lock ) {
					_s( 'body' ).addClass( 'overflow-hidden' );
				} else {
					_s( 'body' ).removeClass( 'overflow-hidden' );
				}
			};

			_header.find( '.dropdown-toggle' ).removeAttr( 'data-bs-toggle' );

			_desktopNavBar.each( desktopNavBar => {
				const _dropdownContainers = _s( desktopNavBar ).find( '.menu-item-has-children' );
				const _dropdownToggles = _dropdownContainers.find( '.dropdown-toggle' );

				_s( desktopNavBar )
					.find( '[href="#"], [href=""]' )
					.closest( 'li' )
					.each( menuItemContainer => {
						_s( menuItemContainer ).on( 'click', e => {
							_s( menuItemContainer ).trigger( 'mouseenter' );
						} );
					} );

				_dropdownToggles.each( dropdownToggle => {
					const _dropdownToggle = _s( dropdownToggle );
					const _dropdownContainer = _dropdownToggle.closest( '.menu-item-has-children' );
					const _dropdown = _dropdownContainer.find( '> .dropdown-menu' );
					const _dropdownItems = _dropdown.find( 'a.dropdown-item' );

					dropdownToggle.dropdownInstance =
						window.bs.Dropdown.getOrCreateInstance( dropdownToggle );

					_dropdownToggle.collapse = () => {
						_dropdownToggle.firstElement().dropdownInstance.hide();
					};

					_dropdownToggle.on( 'shown.bs.dropdown', () => {
						_dropdownToggle.closest( '.menu-item' ).addClass( 'dropdown-expanded' );
					} );

					_dropdownToggle.on( 'hidden.bs.dropdown', () => {
						_dropdownToggle.closest( '.menu-item' ).removeClass( 'dropdown-expanded' );
					} );

					_dropdownContainer.on( 'mouseenter', e => {
						if ( ! _dropdownToggle.hasClass( 'show' ) ) {
							dropdownToggle.dropdownInstance.show();
						}
					} );

					_dropdownContainer.on( 'mouseleave', e => {
						if ( _dropdownToggle.hasClass( 'show' ) ) {
							dropdownToggle.dropdownInstance.hide();
							dropdownToggle.blur();
						}
					} );

					_dropdownToggle.on( 'keydown', e => {
						if ( [ 'ArrowDown', 'ArrowUp' ].includes( e.key ) ) {
							e.preventDefault();
							if ( e.key == 'ArrowDown' ) {
								if ( ! isSubmenuExpanded( _dropdownToggle ) ) {
									dropdownToggle.dropdownInstance.show();
								} else {
									/** Set focus on the first item of the dropdown */
									const firstItem = _dropdownToggle
										.closest( '.menu-item' )
										.find( '> .dropdown-menu' )
										.find( 'a' )
										.firstElement();
									if ( firstItem ) {
										firstItem.focus();
									}
								}
							} else {
								dropdownToggle.dropdownInstance.hide();
							}
						}
						if ( e.key == 'ArrowRight' ) {
							const next = _dropdownToggle
								.closest( '.menu-item' )
								.firstElement().nextElementSibling;
							const _next = _s( next );

							if ( _next.hasClass( 'menu-item' ) ) {
								_next.find( '.dropdown-toggle' ).each( toggle => {
									toggle.focus();
								} );
							}
						}
						if ( e.key == 'ArrowLeft' ) {
							const previous = _dropdownToggle
								.closest( '.menu-item' )
								.firstElement().previousElementSibling;
							const _previous = _s( previous );

							if ( _previous.hasClass( 'menu-item' ) ) {
								_previous.find( '.dropdown-toggle' ).each( toggle => {
									toggle.focus();
								} );
							}
						}
					} );

					_dropdownToggle.on( 'blur', e => {
						const _relatedTarget = _s( e.relatedTarget );
						const targetItemClass = _relatedTarget
							.closest( '.menu-item' )
							.attr( 'class' );

						if (
							isSubmenuExpanded( _dropdownToggle ) &&
							! _dropdownToggle
								.closest( '.menu-item' )
								.find( '[class="' + targetItemClass + '"]' ).length
						) {
							dropdownToggle.dropdownInstance.hide();
						}
					} );

					_dropdownItems.on( 'blur', e => {
						const _relatedTarget = _s( e.relatedTarget );
						if ( ! _relatedTarget.closest( '.dropdown-expanded' ).length ) {
							dropdownToggle.dropdownInstance.hide();
						}
					} );

					const focusNext = _currentMenuItem => {
						if ( _currentMenuItem.length ) {
							let nextMenuItem = _currentMenuItem.firstElement().nextElementSibling;
							let _nextMenuItem = _s( nextMenuItem );

							if ( _nextMenuItem.length ) {
								_nextMenuItem.find( '> .dropdown-item' ).each( dropdownItem => {
									dropdownItem.focus();
								} );
							} else {
								focusNext(
									_currentMenuItem.closest( '.menu-item.menu-item-has-children' )
								);
							}
						}
					};

					const focusPrev = _currentMenuItem => {
						if ( _currentMenuItem.length ) {
							let previousMenuItem =
								_currentMenuItem.firstElement().previousElementSibling;
							let _previousMenuItem = _s( previousMenuItem );

							if ( _previousMenuItem.length ) {
								_previousMenuItem.find( 'a' ).lastElement().focus();
							} else if ( _currentMenuItem.closest( '.dropdown-menu' ).length ) {
								const _dropdownItem = _currentMenuItem
									.closest( '.menu-item.menu-item-has-children' )
									.find( '> a' );

								_dropdownItem.each( dropdownItem => {
									dropdownItem.focus();
								} );
							}
						}
					};

					_dropdownItems.on( 'keydown', e => {
						if ( ! [ 'ArrowUp', 'ArrowDown' ].includes( e.key ) ) return;

						const _item = _s( e.target );
						const _parent = _item.closest( '.menu-item' );

						if ( e.key === 'ArrowDown' ) {
							if ( _parent.hasClass( 'menu-item-has-children' ) ) {
								_parent
									.find( '> .dropdown-menu' )
									.find( '> .menu-item:first-child' )
									.find( 'a' )
									.each( menuItem => {
										menuItem.focus();
									} );
							} else {
								focusNext( _parent );
							}
						}

						if ( e.key === 'ArrowUp' ) {
							focusPrev( _parent );
						}
					} );
				} );
			} );

			// ─── MOBILE NAV DRAWER (members only) ───
			// Not a Bootstrap collapse: the design slides the links panel in from the
			// right and fades a scrim behind it (designs/events.html:1929). The burger
			// is only rendered for logged-in users, so this whole block no-ops when
			// logged out — which is correct, that nav has no drawer.
			const _burger = _header.find( '.navbar-toggler' );
			const burgerEl = _burger.firstElement();

			if ( burgerEl ) {
				const _drawerBackdrop = _header.find( '.nav-drawer-backdrop' );
				const _navRow = _header.find( '.navbar' );

				const isDrawerOpen = () => _s( 'body' ).hasClass( 'navdrawer-open' );

				// The panel and scrim start below the bar, so they need the bar's real
				// height rather than a hardcoded 64px (designs/events.html:1937).
				const setDrawerTop = () => {
					const navRowEl = _navRow.firstElement();
					if ( ! navRowEl ) return;
					window.setRootProperty(
						'--drawer-top',
						Math.max( 0, Math.round( navRowEl.getBoundingClientRect().bottom ) ) + 'px'
					);
				};

				const setDrawer = open => {
					if ( open ) setDrawerTop();

					_s( 'body' ).toggleClass( 'navdrawer-open', open );
					bodyOverflowHidden( open );
					_burger.attr( 'aria-expanded', open ? 'true' : 'false' );
					// Labels come from data attributes so they stay translatable in Blade.
					const label = open
						? burgerEl.dataset.labelClose
						: burgerEl.dataset.labelOpen;
					if ( label ) _burger.attr( 'aria-label', label );
				};

				_burger.on( 'click', e => {
					e.preventDefault();
					setDrawer( ! isDrawerOpen() );
				} );

				// Clicking the scrim closes it (designs/events.html:1945).
				_drawerBackdrop.on( 'click', () => setDrawer( false ) );

				// Escape closes and returns focus to the burger (designs/events.html:1949).
				_s( document ).on( 'keydown', e => {
					if ( e.key === 'Escape' && isDrawerOpen() ) {
						setDrawer( false );
						burgerEl.focus();
					}
				} );

				// Following a link should not leave the drawer + scroll lock behind.
				_header.find( '.nav-links a' ).on( 'click', () => {
					if ( isDrawerOpen() ) setDrawer( false );
				} );

				// Crossing back above the drawer breakpoint must clear the open state,
				// or the body stays scroll-locked with the panel back inline.
				const drawerBreakpoint = window.matchMedia( '(max-width: 880px)' );
				const onBreakpointChange = () => {
					if ( ! drawerBreakpoint.matches && isDrawerOpen() ) setDrawer( false );
				};
				if ( drawerBreakpoint.addEventListener ) {
					drawerBreakpoint.addEventListener( 'change', onBreakpointChange );
				}

				_s( window ).on( 'resize', () => {
					if ( isDrawerOpen() ) setDrawerTop();
				} );
			}

			/** Set the value for --notification-bar-height variable */
			const notificationBarHeight = () => {
				if ( _notificationBar.length ) {
					window.setRootProperty(
						'--notification-bar-height',
						parseInt( _notificationBar.outerHeight() ) + 'px'
					);
				}
			};

			const initLogorResizeObserver = () => {
				_logo.each( logo => {
					const logoResizeObserver = new ResizeObserver( () => {
						_s( window ).trigger( 'fr:logo-resized' );
					} );

					logoResizeObserver.observe( logo );
				} );
			};

			const initHeaderResizeObserver = () => {
				_header.each( header => {
					const headerResizeObserver = new ResizeObserver( entries => {
						for ( let entry of entries ) {
							const { height } = entry.contentRect;

							if ( entry.target.dataset.prevHeight !== height.toString() ) {
								entry.target.dataset.prevHeight = height.toString();

								_s( window ).trigger( 'fr:header-resized' );
							}
						}
					} );

					headerResizeObserver.observe( header );
				} );
			};

			_s( window ).on( 'scroll', () => {
				scroll();
			} );

			_s( window ).on( 'resize', () => {
				_s( window ).trigger( 'fr:set-body-top-padding' );
				notificationBarHeight();
			} );

			_s( window ).on( 'fr:set-body-top-padding-updated', () => {
				autohideOnScrollHeight = parseInt( window.getRootProperty( '--body-top-padding' ) );
			} );

			_s( window ).on( 'fr:logo-resized fr:header-resized', () => {
				_s( window ).trigger( 'fr:set-body-top-padding' );
			} );

			notificationBarHeight();

			initLogorResizeObserver();

			initHeaderResizeObserver();
		} );
	};

	_s( document ).ready( () => {
		_s( '#app > header.banner' ).header();
	} );
} )( window._s );
